namespace Solovis.Reports.ReportHelpers.ExposureWorldMap {

  export class ExposureWorldMapReportGenerator {

    public static generateReportDefinition() {
      let dataSourceForExposureLineItems = {
        name: "exposureLineItems",
        path: "/Solovis/Exposure/AggregateExposureOverTime",

        parameterMap: function (parameters, more) {
          let params: any = {};

          let combinedSelectionSet = InvData.SelectionSetHelper.unionAssetListWithSelectionSet(parameters.assetList, parameters.assetSelectionSet);

          params.componentSelectionSet = combinedSelectionSet;

          params.exposureRef = {
            exposureType: parameters.exposureType
          };

          if (parameters.profile) {
            params.exposureRef.profileId = parameters.profile.id;
          }

          if (parameters.tagSet) {
            params.exposureRef.tagSetId = parameters.tagSet.id;
          }

          if (parameters.asOfDayId) {
            params.dayId = parameters.asOfDayId;
          }
          else {
            params.dayId = InvData.DayId.today();
          }

          params.periodLength = parameters.periodLength;
          params.periodsBack = parameters.periodsBack;

          if (parameters.targetCurrency) {
            params.targetCurrencyId = parameters.targetCurrency.id;
          }

          if (parameters.sourceData) {
            params.useBookedValues = parameters.sourceData.useBookedValues;
            params.knowledgeDateTimestamp = parameters.sourceData.knowledgeDateTimestamp;
          }

          params.includeTagSet = true;

          return params;
        },

        postProcess: function (loadedDataSet, more) {
          let exposureMeasure = more.originalParameters.exposureMeasure;
          let overallByDay = loadedDataSet.overallByDay;

          var groupingsByDay = [];
          $(overallByDay).each(function (i, overall) {
            groupingsByDay.push({});
          });

          var getOrCreateRegion = function (regionName, dayIndex) {
            var region = groupingsByDay[dayIndex][regionName];
            if (!region) {
              region = {
                name: regionName,
                items: [],
                exposureValue: 0,
                exposureAmount: 0,
              };
              groupingsByDay[dayIndex][regionName] = region;
            }
            return region;
          };

          $(loadedDataSet.groups).each(function (i, group: any) {
            $(group.byDay).each(function (dayIndex, dayEntry: any) {
              let lineItem: any = {
                runId: group.runId,
                parentRunId: group.parentRunId,
                label: group.label,
                fullLabelPath: group.fullLabelPath,
                dayId: dayEntry.dayId,
                isLeaf: group.isLeaf
              };

              lineItem.fullGroupNodeId = group.runId + "-" + dayEntry.dayId;
              if (Solovis.isNotNull(group.parentRunId)) {
                lineItem.fullParentGroupNodeId = group.parentRunId + "-" + dayEntry.dayId;
              }

              lineItem.long = dayEntry.long;
              lineItem.short = dayEntry.short;
              lineItem.net = dayEntry.long + dayEntry.short;
              lineItem.gross = dayEntry.long - dayEntry.short;

              var overall = overallByDay[dayIndex];
              if (overall.overallValue) {
                lineItem.longPercentage = lineItem.long / overall.overallValue;
                lineItem.shortPercentage = lineItem.short / overall.overallValue;
                lineItem.netPercentage = lineItem.net / overall.overallValue;
                lineItem.grossPercentage = lineItem.gross / overall.overallValue;
              }

              var region = getOrCreateRegion(lineItem.label, dayIndex);

              let partialExposureValue = 0;
              switch (exposureMeasure) {
                case "Long": partialExposureValue = lineItem.longPercentage; break;
                case "Short": partialExposureValue = lineItem.shortPercentage; break;
                case "Net": partialExposureValue = lineItem.netPercentage; break;
                case "Gross": partialExposureValue = lineItem.grossPercentage; break;
              }

              let partialExposureAmount = 0;
              switch (exposureMeasure) {
                case "Long": partialExposureAmount = lineItem.long; break;
                case "Short": partialExposureAmount = lineItem.short; break;
                case "Net": partialExposureAmount = lineItem.net; break;
                case "Gross": partialExposureAmount = lineItem.gross; break;
              }

              region.exposureValue += partialExposureValue;
              region.exposureAmount += partialExposureAmount;
            });
          });

          let baseColor = Color.FromSingleNumber(245);
          let isThreshold = more.originalParameters.color == "Threshold";
          let colorBuckets = isThreshold ?
            [
              new ColorBucket(-.15, new Color(179, 86, 1)),
              new ColorBucket(-.1, new Color(224, 119, 22)),
              new ColorBucket(-.05, new Color(246, 141, 44)),
              new ColorBucket(-.01, new Color(255, 180, 110)),
              new ColorBucket(-.000001, new Color(255, 218, 184)),
              new ColorBucket(0.000001, baseColor),
              new ColorBucket(.01, new Color(139, 209, 233)),
              new ColorBucket(.05, new Color(80, 185, 218)),
              new ColorBucket(.1, new Color(0, 146, 188)),
              new ColorBucket(.15, new Color(0, 104, 133)),
              new ColorBucket(1, new Color(0, 64, 82)),
            ] :
            [
              new ColorBucket(-1.0, new Color(0, 0, 255)),
              new ColorBucket(-0.00000100001, new Color(225, 225, 225)),
              new ColorBucket(-0.000001, baseColor),
              new ColorBucket(0.000001, baseColor),
              new ColorBucket(0.00000100001, new Color(225, 250, 225)),
              new ColorBucket(1.0, new Color(0, 255, 0)),
            ];
          let colorBucketer = new ColorPickerByBucket(colorBuckets, baseColor)

          $(groupingsByDay).each(function (i, groupings) {
            for (let name in groupings) {
              let region = groupings[name];
              region.color = isThreshold ?
                colorBucketer.GetColorStringThreshold(region.exposureValue) :
                colorBucketer.GetColorStringGradient(region.exposureValue);
            }
          });

          var dataSet = {
            overallByDay: overallByDay,
            regionGroupingsByDay: groupingsByDay,
            originalDataSet: loadedDataSet,
            defaultColor: baseColor.ToCss(),
            tagSet: loadedDataSet.tagSet
          };

          return dataSet;
        }
      };

      const percentFormatter = InvData.FormatterHelper.getPercentageFormatter({ decimalPlaces: 3 });
      const percentFormatterSingle = InvData.FormatterHelper.getPercentageFormatter({ decimalPlaces: 1 });
      const decimalFormatter = InvData.FormatterHelper.getNumberFormatter({ decimalPlaces: 2 });

      var report = {
        fullWidth: true,
        autoSizeSpaceAvailable: true,
        parameters: [
          {
            name: "assetList", label: "Assets", parameterType: "entityOrInvestment", list: true,
            help: "All of the individual specified assets will be combined to create a composite for exposure analysis."
          },

          { name: "assetSelectionSet", label: "Asset Selection Set", parameterType: "assetSelectionSet" },

          { name: "asOfDayId", label: "As Of", parameterType: "dateIndex" },

          {
            name: "periodLength",
            label: "Period Length",
            parameterType: "choice",
            initialValue: "Month",
            settings: {
              options: [
                { label: "Day", value: "Day" },
                { label: "Month", value: "Month" },
                { label: "Quarter", value: "Quarter" },
                { label: "Year", value: "Year" },
                { label: "Fiscal Year", value: "FiscalYear" }
              ]
            }
          },

          { name: "periodsBack", label: "Periods Back", parameterType: "integer" },

          { name: "profile", label: "Profile", parameterType: "exposureProfile" },
          { name: "tagSet", label: "Tag Set", parameterType: "tagSet", settings: { dependsOn: { exposureProfile: "profile" } } },

          {
            name: "exposureType",
            label: "Exposure Type",
            parameterType: "choice",
            initialValue: "MarketValue",
            settings: {
              options: [
                { label: "Market Value", value: "MarketValue" },
                { label: "Notional", value: "Notional" },
                { label: "Delta-Adjusted Notional", value: "DeltaAdjustedNotional" }
              ]
            }
          },
          {
            name: "exposureMeasure", label: "Exposure Measure", parameterType: "choice", initialValue: "Net",
            settings: {
              options: [
                { label: "Long", value: "Long" },
                { label: "Short", value: "Short" },
                { label: "Net", value: "Net" },
                { label: "Gross", value: "Gross" }
              ]
            }
          },

          { name: "targetCurrency", label: "Target Currency", parameterType: "currency" },

          {
            name: "sourceData", label: "Source Data", parameterType: "sourceData",
            settings: { hideStoredPerformance: true, hideAttributionBenchmarkSource: true, hideUseBlendedValues: true }
          },

          {
            name: "color", label: "Color", parameterType: "choice", initialValue: "Gradient",
            settings: {
              options: [
                { label: "Gradient", value: "Gradient" },
                { label: "Threshold", value: "Threshold" }
              ]
            }
          },
        ],
        root: {
          elementName: "Root",
          layout: "Vertical",
          children: [
            {
              partControl: "Solovis.Reports.Parts.HtmlControl",
              elementName: "ExposureMap",
              dataSources: [
                { name: "exposureLineItems", ref: { elementName: "Root", dataSourceName: "exposureLineItems" } }
              ],
              style: { height: "100%" },
              requiredModules: ["devextreme-map-world"],
              settings: {
                render: function () {
                  if (!this.dataSets.exposureLineItems) {
                    return;
                  }

                  var thisReportPart = this;
                  let defaultColor = this.dataSets.exposureLineItems.defaultColor;

                  var mapState = this.__reportMapState;
                  if (!mapState) {
                    mapState = {
                      customizeElementsForCurrentDayIdIndex: function (elements) {
                        var self = this;
                        var regionGroupings = self.regionGroupingsByDay[this.currentDayIdIndex];
                        $.each(elements, function (_, element) {
                          let regionName = element.attribute("name");
                          let region = regionGroupings[regionName];
                          const exposureValue = (region && region.exposureValue) ? region.exposureValue : 0;
                          element.attribute("exposureValue", exposureValue);
                          if (exposureValue != 0) {
                            element.attribute("exposurePercent", percentFormatterSingle.format(exposureValue));
                          }
                          element.applySettings({
                            color: (region && region.color) ? region.color : defaultColor
                          });
                        });
                      },

                      applyStateForCurrentDayIdIndex: function () {
                        var dxVectorMap = thisReportPart.__dxVectorMap;
                        if (dxVectorMap) {
                          var elements = dxVectorMap.getLayers()[0].getElements();
                          this.customizeElementsForCurrentDayIdIndex(elements);
                          this.updateTitle();
                        }
                      },

                      updateTitle: function () {
                        var dxVectorMap = thisReportPart.__dxVectorMap;
                        if (dxVectorMap) {
                          dxVectorMap.option("title", this.getTitleForCurrentDayIdIndex());
                        }
                      },

                      getCurrentDayId: function () {
                        let overallForDay = this.overallByDay[this.currentDayIdIndex];
                        return overallForDay.dayId;
                      },

                      getTitleForCurrentDayIdIndex: function () {
                        var overallForDay = this.overallByDay[this.currentDayIdIndex];

                        return {
                          text: "Exposure",
                          subtitle: {
                            text: InvData.DayId.format(overallForDay.dayId)
                          }
                        };
                      },

                      startAnimation: function (fromStart) {
                        var thisMapState = this;
                        if (this._animationIntervalHandle) {
                          clearInterval(this._animationIntervalHandle);
                          delete this._animationIntervalHandle;
                        }

                        if (fromStart) {
                          thisMapState.currentDayIdIndex = 0;
                          thisMapState.applyStateForCurrentDayIdIndex();
                        }

                        this._animationIntervalHandle = setInterval(function () {
                          if (!Solovis.UI.DomHelper.isDescendantOf(thisReportPart.container, document.body)) {
                            thisMapState.stopAnimation();
                          }

                          if (thisMapState.animationLoop) {
                            thisMapState.currentDayIdIndex = (thisMapState.currentDayIdIndex + 1) % thisMapState.overallByDay.length;
                            thisMapState.applyStateForCurrentDayIdIndex();
                          }
                          else {
                            if (thisMapState.currentDayIdIndex < (thisMapState.overallByDay.length - 1)) {
                              thisMapState.currentDayIdIndex++;
                              thisMapState.applyStateForCurrentDayIdIndex();
                            }
                            else {
                              thisMapState.stopAnimation();
                            }
                          }
                        }, thisMapState.animationSpeed);
                      },

                      stopAnimation: function () {
                        if (this._animationIntervalHandle) {
                          clearInterval(this._animationIntervalHandle);
                          delete this._animationIntervalHandle;
                        }
                      },

                      isPlaying: function () {
                        return !!this._animationIntervalHandle;
                      },

                      stepBack: function () {
                        if (this.currentDayIdIndex > 0) {
                          this.currentDayIdIndex--;
                          this.applyStateForCurrentDayIdIndex();
                        }
                      },

                      stepForward: function () {
                        if (this.currentDayIdIndex < (this.overallByDay.length - 1)) {
                          this.currentDayIdIndex++;
                          this.applyStateForCurrentDayIdIndex();
                        }
                      },

                      animationSpeed: 300,
                      animationLoop: false,

                      getContextMenuLinks: function () {
                        let dayId = this.getCurrentDayId();
                        let parameters = thisReportPart.parameters;
                        let exposure = thisReportPart.dataSets.exposureLineItems;

                        // Exposure Roll-up Line Items
                        let reportCodeForExposureRollUpLineItems = "FEC0D928-9E3D-4FE5-804C-0ECEEF9D8E35";
                        let exposureRollUpParams = Solovis.Reports.ReportHelpers.AggregateExposureOverTime.AggregateExposureOverTimeReportGenerator.copyExposureRollUpLineItemsParametersFromCoreExposureReportParameters(parameters, dayId);
                        let exposureRollUpPersistedSettings: any = {};
                        if (exposure && exposure.tagSet && exposure.tagSet.id > 0) {
                          // The grouping name for the tag set in exposure roll-up line items is tagSet<TagSetId>.
                          exposureRollUpPersistedSettings.ExposureTable = {
                            "groupBy": [{ "id": "all" }, { "id": "tagSet" + exposure.tagSet.id }]
                          };
                        }

                        let exposureRollUpUrl = Solovis.Reports.ReportLinker.getReportLink({
                          reportCode: reportCodeForExposureRollUpLineItems,
                          parameters: exposureRollUpParams,
                          persistedSettings: exposureRollUpPersistedSettings,
                          autoRun: true
                        });
                        let exposureRollUpLabel = "Exposure Roll-up Line Items"
                        if (dayId) {
                          exposureRollUpLabel += " - " + InvData.DayId.format(dayId);
                        }

                        // Aggregate Exposure Over Time
                        let reportCodeForAggregateExposureOverTime = "4CEDDA66-BC11-47AD-B366-914DF96CEDBF";
                        let aggExpParams = Solovis.Reports.ReportHelpers.AggregateExposureOverTime.AggregateExposureOverTimeReportGenerator.copyCoreExposureParametersFromCoreExposureReportParameters(parameters);
                        let aggExpUrl = Solovis.Reports.ReportLinker.getReportLink({
                          reportCode: reportCodeForAggregateExposureOverTime,
                          parameters: aggExpParams,
                          autoRun: true
                        });
                        let aggExpLabel = "Aggregate Exposure Over Time";

                        let links = [];

                        links.push({
                          label: exposureRollUpLabel,
                          href: exposureRollUpUrl
                        });

                        links.push({
                          label: aggExpLabel,
                          href: aggExpUrl
                        });

                        return links;
                      },

                      activeContextMenu: null,
                      hideContextMenuIfAlreadyShown: function () {
                        if (this.activeContextMenu) {
                          if (this.activeContextMenu.dxContextMenuInstance) {
                            // Work-around for dxVectorMap intecepting click events in way
                            // that prevents previous context menu from being hidden.
                            this.activeContextMenu.dxContextMenuInstance.hide();
                          }
                          this.activeContextMenu = null;
                        }
                      }
                    };
                    this.__reportMapState = mapState;
                  };

                  mapState.regionGroupingsByDay = this.dataSets.exposureLineItems.regionGroupingsByDay;
                  mapState.currentDayIdIndex = mapState.regionGroupingsByDay.length - 1;
                  mapState.overallByDay = this.dataSets.exposureLineItems.overallByDay;

                  if (this.__dxVectorMap) {
                    this.__dxVectorMap.dispose();
                    $(this.container).html("");
                  }

                  this.container.css("padding-bottom", "40px");

                  var vectorDiv = $("<div>").appendTo(this.container).css("height", "100%");

                  var toolbarDiv = $("<div>").appendTo(this.container);
                  $(toolbarDiv).dxToolbar({
                    items: [
                      {
                        location: 'before',
                        widget: 'dxButton',
                        options: {
                          icon: 'fa fa-step-backward',
                          hint: "Step Back",
                          onClick: function () {
                            mapState.stepBack();
                          }
                        }
                      },
                      {
                        location: 'before',
                        widget: 'dxButton',
                        options: {
                          icon: 'fa fa-play',
                          hint: "Play",
                          onClick: function () {
                            if (mapState.isPlaying()) {
                              mapState.stopAnimation();
                            }
                            else {
                              mapState.startAnimation(true);
                            }
                          }
                        }
                      },
                      {
                        location: 'before',
                        widget: 'dxButton',
                        options: {
                          icon: 'fa fa-step-forward',
                          hint: "Step Forward",
                          onClick: function () {
                            mapState.stepForward();
                          }
                        }
                      }
                    ]
                  });

                  let vectorMapOptions: any = {
                    layers: {
                      name: "areas",
                      dataSource: (DevExpress.viz.map as any).sources.world,
                      label: {
                        enabled: true,
                        dataField: "exposurePercent"
                      },
                      customize: function (elements) {
                        mapState.customizeElementsForCurrentDayIdIndex(elements);
                      }
                    },
                    title: mapState.getTitleForCurrentDayIdIndex(),
                    export: {
                      enabled: true
                    },
                    tooltip: {
                      enabled: true,
                      contentTemplate: function (info, container) {
                        let regionGroupings = mapState.regionGroupingsByDay[mapState.currentDayIdIndex];
                        let name = info.attribute("name");
                        let region = regionGroupings[name];

                        $("<div>").text(name).appendTo(container);

                        if (region) {
                          let expStr = percentFormatter.format(region.exposureValue);

                          $("<div>").text(expStr).appendTo(container);

                          let amountStr = decimalFormatter.format(region.exposureAmount);
                          let currencyCode = thisReportPart.dataSets.exposureLineItems.originalDataSet.currencyCode;
                          $("<div>").text(amountStr + " " + currencyCode).appendTo(container);
                        }
                      }
                    },
                    projection: "miller",
                    bounds: [-180, 85, 180, -60],
                    onClick: function (e) {
                      let event = e.event;
                      if (event.button == 2) {
                        // Right-mouse button is 2.
                        let links = mapState.getContextMenuLinks();

                        mapState.hideContextMenuIfAlreadyShown();
                        mapState.activeContextMenu = Solovis.UI.PopupLinkPanel.showLinks({
                          links: links,
                          offset: event
                        });
                      }
                    }
                  };

                  $(vectorDiv).dxVectorMap(vectorMapOptions);
                  this.__dxVectorMap = $(vectorDiv).dxVectorMap("instance");
                }
              }
            }
          ],
          dataSources: [
            dataSourceForExposureLineItems
          ]
        }
      };

      return report;
    };
  }

  class ColorPickerByBucket {
    private buckets: ColorBucket[];
    private defaultColor: Color;

    constructor(colorBuckets: ColorBucket[], defaultColor: Color) {
      this.buckets = colorBuckets;
      this.defaultColor = defaultColor;
    }

    GetColorStringGradient(value: number): string {
      if (!isNaN(value)) {
        let lastColor: Color = null;
        let nextColor: Color = null;
        let lastCutoff = null;
        let nextCutoff = null;

        let foundBucket = false;
        let nextIndex = 0;
        while ((nextIndex <= this.buckets.length) && !foundBucket) {
          if (nextIndex == this.buckets.length) {
            lastColor = nextColor;
            nextColor = null;
            lastCutoff = nextCutoff;
            nextCutoff = null;
          }
          else {
            let colorBucket = this.buckets[nextIndex];

            lastColor = nextColor;
            nextColor = colorBucket.color;
            lastCutoff = nextCutoff;
            nextCutoff = colorBucket.cutoff;

            if (value <= colorBucket.cutoff) {
              foundBucket = true;
            }
          }

          nextIndex++;
        }

        if (!nextColor) {
          if (lastColor) {
            return lastColor.ToCss();
          }
        }
        else if (!lastColor) {
          if (nextColor) {
            return nextColor.ToCss();
          }
        }
        else {
          let range = (nextCutoff - lastCutoff);
          let progress = (value - lastCutoff);
          let percentageProgress = progress / range;

          let blendedColor = lastColor.BlendWith(nextColor, percentageProgress);
          return blendedColor.ToCss();
        }
      }
      else {
        return this.defaultColor.ToCss();
      }
    }

    GetColorStringThreshold(value: number): string {
      if (!isNaN(value)) {
        let nextIndex = 0;
        while (nextIndex < this.buckets.length) {
          let colorBucket = this.buckets[nextIndex];
          if (value < colorBucket.cutoff) {
            return colorBucket.color.ToCss();
          }

          nextIndex++;
        }

        return this.buckets[nextIndex - 1].color.ToCss();
      }
      else {
        return this.defaultColor.ToCss();
      }
    }
  }

  class ColorBucket {
    public cutoff: number;
    public color: Color;

    constructor(cutoff: number, c: Color) {
      this.cutoff = cutoff;
      this.color = c;
    }
  }

  class Color {
    private r: number;
    private g: number;
    private b: number;

    constructor(r: number, g: number, b: number) {
      this.r = r;
      this.g = g;
      this.b = b;
    }

    static FromSingleNumber(rgb: number): Color {
      return new Color(rgb, rgb, rgb);
    }

    ToCss(): string {
      return "rgb(" + this.r + "," + this.g + "," + this.b + ")";
    }

    BlendWith(color: Color, percentage: number): Color {
      return new Color(
        (color.r - this.r) * percentage + this.r,
        (color.g - this.g) * percentage + this.g,
        (color.b - this.b) * percentage + this.b
      );
    }
  }
}
